import { withQuery } from "./query";
import { Get } from "./request";

export function GetDataImportAvailableColumns(dispatch) {
  return Get(dispatch, "GetDataImportAvailableColumns");
}

export function GetDataImportStatus(dispatch, importId) {
  return Get(dispatch, withQuery("GetDataImportStatus", { importId }));
}

export function GetWarehouseSources(dispatch) {
  return Get(dispatch, "GetWarehouseSources");
}
